"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const units_service_1 = require("./units.service");
const configuration_1 = require("@common/configuration");
class AccessesService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpointBaseUrl = configuration_1.Configuration.unitsServiceConfig().apiV2;
    }
    async getUnitAccesses(legacyUnitId) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access?filter[unit_id]=${legacyUnitId}&include=access_purpose,lock_type`, { headers: this.getHeaders() });
        return response.data;
    }
    async getUnitMainAccess(legacyUnitId) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access?filter[unit_id]=${legacyUnitId}&filter[is_main]=true`, { headers: this.getHeaders() });
        return response.data;
    }
    async getUnitAccessesByPurpose(legacyUnitId, purposeId) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access?filter[unit_id]=${legacyUnitId}&filter[purpose_id]=${purposeId}`, { headers: this.getHeaders() });
        return response.data;
    }
    async getAccessesById(id, maskInstructions = true, userEmail) {
        let filter = '?include=lock_model';
        if (!maskInstructions) {
            //@ts-ignore
            const reason = prompt(`Access to this sensitive data will be logged for security purposes. 
Please provide a reason for accessing this information.`);
            if (!reason || reason.trim().length <= 1)
                throw new Error("You cannot view lockbox codes without a valid reason. ");
            filter = `?filter[masked_instructions]=false&include=lock_model&filter[reason]=${encodeURIComponent(reason)}`;
        }
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access/${id}${filter}`, { headers: { "User-Email": Buffer.from(userEmail).toString('base64'), ...this.getHeaders() } });
        return response.data;
    }
    async getAccessTypeById(id) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access-types/${id}`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getPurposesByAccessType(accessType) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access-purposes?filter[access_type_id]=${accessType}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getLockTypeByAccessType(accessType) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/lock-types?filter[access_type_id]=${accessType}`, {
            headers: this.getHeaders(),
        });
        return response.data.data;
    }
    async getLockTypeConfigurationsByLockType(lockTypeId, isSmartHome) {
        let filter = `filter[lock_type_id]=${lockTypeId}${!isSmartHome ? '&filter[is_smarthome]=false' : ''}`;
        const response = await this.httpService.get(`${this.endpointBaseUrl}/lock-types-configuration?${filter}&include=configuration_type`, { headers: this.getHeaders() });
        return response.data;
    }
    async getAccessConfigurationById(configId, masked = true, userEmail) {
        let filters = '';
        if (!masked) {
            //@ts-ignore
            const reason = prompt(`Access to this sensitive data will be logged for security purposes. 
Please provide a reason for accessing this information.`);
            if (!reason || reason.trim().length <= 1)
                throw new Error("You cannot view lockbox codes without a valid reason. ");
            filters = `?filter[masked]=false&filter[reason]=${encodeURIComponent(reason)}`;
        }
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access-configuration/${configId}${filters}`, { headers: { "User-Email": Buffer.from(userEmail).toString('base64'), ...this.getHeaders() } });
        return response.data.data;
    }
    async updateUnitAccesses(id, unitAccess) {
        const response = await this.httpService.patch(`${this.endpointBaseUrl}/access/${id}`, { data: unitAccess }, { headers: this.getHeaders() });
        return response.data;
    }
    async updateUnitAccessesSequence(unitId, unitAccess) {
        const response = await this.httpService.post(`${this.endpointBaseUrl}/access/unit/${unitId}/access-sequence`, { data: unitAccess }, { headers: this.getHeaders() });
        return response.data;
    }
    async getUnitAccessNotes(legacyUnitId) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/access-unit/${legacyUnitId}`, { headers: this.getHeaders() });
        return response.data;
    }
    async updateUnitAccessNotes(id, unitAccess) {
        const response = await this.httpService.patch(`${this.endpointBaseUrl}/access-unit/${id}`, { data: unitAccess }, { headers: this.getHeaders() });
        return response.data;
    }
    async createUnitAccesses(unitAccess) {
        const response = await this.httpService.post(`${this.endpointBaseUrl}/access`, { data: unitAccess }, { headers: this.getHeaders() });
        return response.data;
    }
    async deleteUnitAccess(id, userEmail) {
        const response = await this.httpService.delete(`${this.endpointBaseUrl}/access/${id}`, { headers: { "User-Email": Buffer.from(userEmail).toString('base64'), ...this.getHeaders() } });
        return response.data;
    }
    async getModelsByLockTypeAndMakeId(lockTypeId, lockMakeId) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/lock-models?filter[lock_type_id]=${lockTypeId}&filter[lock_maker_id]=${lockMakeId}`, { headers: this.getHeaders() });
        return response.data;
    }
    async getModels() {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/lock-models`, { headers: this.getHeaders() });
        return response.data;
    }
    async getModelsByLockType(lockTypeId) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/lock-models?filter[lock_type_id]=${lockTypeId}`, { headers: this.getHeaders() });
        return response.data;
    }
    async getMakesByLockType(lockTypeId) {
        const response = await this.httpService.get(`${this.endpointBaseUrl}/lock-makers?filter[lock_type_id]=${lockTypeId}`, { headers: this.getHeaders() });
        return response.data;
    }
    async syncSmartHome(request) {
        const response = await this.httpService.post(`${this.endpointBaseUrl}/access/smarthome/sync`, { data: request }, { headers: this.getHeaders() });
        return response.data;
    }
}
exports.AccessesService = AccessesService;
//# sourceMappingURL=accesses.service.js.map